import { firma } from '../content';
import './letterhead.css';

/**
 * Briefbogen "Manuel Schneider Dienstleistungen" nach DIN 5008 Form B.
 *
 * WARUM ich-Form: Der Briefbogen ist Eins-zu-eins-Korrespondenz, keine
 * Sammelaussendung. content.ts legt fest, dass persoenliche Korrespondenz
 * als ICH spricht (Sammelmaterial wie der Flyer dagegen als WIR) - deshalb
 * hier firma.mailPersoenlich statt firma.mailAllgemein, und ein Blindtext,
 * der bewusst "ich" statt "wir" verwendet.
 *
 * Anschrift und Datum sind Platzhalter (Empfänger ist bei einer leeren
 * Vorlage naturgemäß nicht bekannt) - alle übrigen Angaben stammen aus
 * content.ts.
 */
export function Letterhead() {
  const heute = new Date().toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  return (
    <div className="letterhead-page">
      <article className="letterhead" aria-label="Briefbogen">
        <span className="letterhead__mark letterhead__mark--fold-upper" aria-hidden="true" />
        <span className="letterhead__mark letterhead__mark--perforation" aria-hidden="true" />
        <span className="letterhead__mark letterhead__mark--fold-lower" aria-hidden="true" />

        <p className="letterhead__wordmark">{firma.name}</p>

        <div className="letterhead__address-window">
          <p className="letterhead__return-line">
            {firma.name} &middot; {firma.strasse} &middot; {firma.ort}
          </p>
          <address className="letterhead__address">
            Platzhalter Empfänger
            <br />
            Musterstra&szlig;e 1
            <br />
            12345 Musterstadt
          </address>
        </div>

        <div className="letterhead__info-block">
          <dl>
            <div className="letterhead__info-row">
              <dt>Ansprechpartner</dt>
              <dd>{firma.inhaber}</dd>
            </div>
            <div className="letterhead__info-row">
              <dt>Telefon</dt>
              <dd>{firma.telefon}</dd>
            </div>
            <div className="letterhead__info-row">
              <dt>E-Mail</dt>
              <dd>{firma.mailPersoenlich}</dd>
            </div>
            <div className="letterhead__info-row">
              <dt>Datum</dt>
              <dd>{heute}</dd>
            </div>
          </dl>
        </div>

        <h1 className="letterhead__subject">Ihr Angebot f&uuml;r die Zusammenarbeit</h1>

        <div className="letterhead__body">
          <p>Sehr geehrte Damen und Herren,</p>
          <p>
            vielen Dank f&uuml;r Ihr Interesse an einer Zusammenarbeit. Gerne &uuml;bernehme ich
            die in unserem Gespr&auml;ch besprochenen Aufgaben und melde mich mit den n&auml;chsten
            Schritten bei Ihnen.
          </p>
          <p>Mit freundlichen Gr&uuml;&szlig;en</p>
          <p>{firma.inhaber}</p>
        </div>

        <footer className="letterhead__footer">
          <div className="letterhead__footer-col">
            <p className="letterhead__footer-heading">Anschrift</p>
            <p>{firma.name}</p>
            <p>{firma.strasse}</p>
            <p>{firma.ort}</p>
          </div>
          <div className="letterhead__footer-col">
            <p className="letterhead__footer-heading">Kontakt</p>
            <p>{firma.telefon}</p>
            <p>{firma.mailAllgemein}</p>
            <p>{firma.web}</p>
          </div>
          <div className="letterhead__footer-col">
            <p className="letterhead__footer-heading">Steuernummer</p>
            <p>{firma.steuernummer}</p>
            <p>{firma.rechtsform}</p>
          </div>
        </footer>
      </article>
    </div>
  );
}
